<div class="wrapper">
  @if (!hasData) {
    <app-create-external-test />
  } @else {
    <app-external-test-details [data]="data" />
  }
  @if (!hasData) {
    <app-actions-section
      [disableAddMenu]="disableAddMenu"
      [label]="!hasData ? 'Create and send' : 'Save'"
      locationStationToolbarContext="external_test"
      class="actions-section w-[455px]"
      />
  }
</div>
